<template>
  <div class="booking-page">
    <booking-header></booking-header>
    <div class="page-wrapper">
      <bookingcontent />
    </div>
    <!-- Footer -->
    <div class="footer-copyright">
      <p>Copyright &copy; 2024. All Rights Reserved.</p>
    </div>
    <!-- /Footer -->
    <!-- Cursor -->
    <div class="xb-cursor tx-js-cursor">
      <div class="xb-cursor-wrapper">
        <div class="xb-cursor--follower xb-js-follower"></div>
      </div>
    </div>
    <!-- /Cursor -->
  </div>
</template>
